//
// RowNumbers.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";

var RowNumbers = createModule("BIRD::RowNumbers", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        visible: 2,
        resetByGroup: 2,
        headerLabel: 7,
        headerVisible: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RowNumbers;
